<ng-container *ngComponentOutlet="getChartContent(); injector: objectInjector"></ng-container>
